import React, { useEffect, useState, useRef } from 'react';
import ceo1 from '@/assets/ceo1.png';
import ceo2 from '@/assets/ceo2.png';

const testimonials = [
  {
    name: 'James Walker',
    city: 'Manchester, UK',
    img: ceo1,
    text: 'From start to finish, the team was professional, efficient, and transparent.',
  },
  {
    name: 'Sarah Thompson',
    city: 'London, UK',
    img: ceo2,
    text: 'We hired them for our office renovation project. The craftsmanship was excellent.',
  },
  {
    name: 'James Walker',
    city: 'Manchester, UK',
    img: ceo1,
    text: 'From start to finish, the team was professional, efficient, and transparent.',
  },
  {
    name: 'Sarah Thompson',
    city: 'London, UK',
    img: ceo2,
    text: 'We hired them for our office renovation project. The craftsmanship was excellent.',
  },
];

export const WhatPeopleSay = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(2);
  const intervalRef = useRef(null);

  // ✅ Set visible count based on screen size
  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(window.innerWidth < 768 ? 1 : 2);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Start auto-slide
  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startAutoSlide = () => {
    stopAutoSlide(); // avoid multiple intervals
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 3000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // ✅ Compute visible testimonials
  const visibleTestimonials = [];
  for (let i = 0; i < visibleCount; i++) {
    visibleTestimonials.push(testimonials[(currentIndex + i) % testimonials.length]);
  }

  return (
    <div className="mt-[0rem] flex w-full justify-center bg-[#121212] py-[3rem] font-inter md:py-[6rem]">
      <div className="flex w-full max-w-[144rem] flex-col items-center gap-y-[3rem] px-[2rem]">
        {/* Header */}

        <h1 className="w-full text-center text-[2.4rem] font-[700] leading-[4rem] text-white md:text-start md:text-[3.2rem] lg:text-[4rem] lg:leading-[5.5rem]">
          What Our Clients Say
        </h1>

        {/* Slider Container */}
        <div
          className="relative w-full overflow-hidden"
          onMouseEnter={stopAutoSlide}
          onMouseLeave={startAutoSlide}
        >
          <div className="flex w-full items-stretch justify-between gap-[2rem] transition-transform duration-700 ease-out">
            {visibleTestimonials.map((item, index) => (
              <div
                key={index}
                className="flex w-full flex-col items-start justify-between rounded-xl bg-[#1C253C] px-[4rem] py-[2rem] transition-transform duration-300 hover:scale-[1.02] md:w-[49%]"
              >
                <div className="flex items-center gap-[1.5rem]">
                  <img src={item.img} alt={item.name} className="h-[9rem] w-[9rem] rounded-full" />
                  <div>
                    <p className="text-[2rem] font-[700] text-white">{item.name}</p>
                    <p className="text-[1.6rem] font-[400] text-[#e45420]">{item.city}</p>
                  </div>
                </div>
                <p className="mt-[1.5rem] text-[1.6rem] font-[400] text-[#DDDDDD]">“{item.text}”</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
